import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../_services/data.service';
import { Page } from '../../_core/_interface/page';
import { Item } from '../../_core/_interface/item';
import { User } from '../../_core/_interface/user';
import { AuthService } from '../../_services/auth.service';
import { slideRight, slideUp } from 'src/app/animations';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-n-page-with-link',
  templateUrl: './n-page-with-link.component.html',
  styleUrls: ['./n-page-with-link.component.scss'],
  animations: [
    slideRight, slideUp
  ],
  host: {
    '[@slideRight]': 'condition'
 }
})
export class NPageWithLinkComponent implements OnInit {
    // @HostBinding('@anim')
    showComponents: boolean = false;
    // @HostBinding('slideRight')
    @HostListener('@slideRight.done', ['$event']) doneDrawerHandler(event: any): void {
      this.showComponents = true;
    }
  parentCollection = "";
  items: Page[] = [];
  selectedItem;
  showPage;
  itemToEdit: Item;
  autoPlay = false;
  showThumbs = false;
  collection = 'pages/';
  activeGalTypeClass: string;
  classOfGalleryType: string[] = ['files', 'scroll', 'simple'];
  galleryType = "";
  user: User;
  activeMobileMenu: boolean;
  showMenuTrigger: boolean = true;
  itemContent: boolean = false;
  galleryId: string = "";
  resizeDrag: boolean;

  @Output()
  closeSubMenu = new EventEmitter<boolean>();

  @Output()
  public showCloser = new EventEmitter<boolean>();

  @Input()
  parentId: string = '';

  @Input()
  showPageWithLinkMenu: boolean;
  mySubscription: any;
  LinkName: any;
  title: string;
  compTitle: string = '';

  constructor(private dataService: DataService, 
    public auth: AuthService, 
    private route: ActivatedRoute, 
    private router: Router,
    private titleService: Title
  ) {
    this.parentId = this.route.snapshot.paramMap.get('idp');
    this.galleryId = this.route.snapshot.paramMap.get('galleryId');
  }

  ngOnInit() {
    // switch (window.location.host) {
    //   case 'getkey1.online':
    //     this.compTitle = 'Get Key 1';
    //     break;
    //   case 's-katorza.com':
    //     this.compTitle = 'S. Katorza';
    //     break;
    //   case 'spirical.net':
    //     this.compTitle = 'Spirikal';
    //     break;
    //   default:
    // }
    this.compTitle = this.dataService.hoisUrlGetTitle();
    this.showPageWithLinkMenu;
    this.parentId;
    this.user = this.auth.currentUserValue;
    this.route.params.subscribe(params => {
      this.galleryId = params.galleryId;
      if (this.parentId !== undefined && this.parentId !== "") {
        this.dataService.getPagesWithLink(this.parentId).subscribe(items => {
          this.items = items;
          console.log("pages-with-linksN", items);
          if (this.items.length < 1) {
            this.showMenuTrigger = false;
          }
          this.itemContent = true;
          this.selectedItem = items[0];
          this.selectedItem = items.filter(gallery => gallery.id === this.galleryId);
          this.selectedItem = this.selectedItem[0];
          if (this.selectedItem) {
            this.showCloser.emit(true);
            this.LinkName = this.selectedItem.LinkName;
            this.pageTitle();
          }
          if (this.parentId === this.galleryId) {
            this.listClick('test', this.items[0]);
            this.showPageWithLinkMenu = true;
          }
        });
      }
    });
    // if (this.parentId !== undefined && this.parentId !== "") {
    //   this.dataService.getPagesWithLink(this.parentId).subscribe(items => {
    //     this.items = items;
    //     console.log("pages-with-linksN", items);
    //     if (this.items.length < 1) {
    //       this.showMenuTrigger = false;
    //     }
    //     this.itemContent = true;
    //     this.selectedItem = items[0];
    //     this.selectedItem = items.filter(gallery => gallery.id === this.galleryId);
    //     this.selectedItem = this.selectedItem[0];
    //     if (this.selectedItem) {
    //       this.showCloser.emit(true);
    //       this.LinkName = this.selectedItem.LinkName;
    //       this.pageTitle();
    //     }
    //     if (this.parentId === this.galleryId) {
    //       this.listClick('test', this.items[0]);
    //       this.showPageWithLinkMenu = true;
    //     }
    //   });
    // }
  }

  pageTitle() {
    // if(this.compTile){
      // if(this.projTile){
        if(this.LinkName){
          // this.title = 'Spirikal' + ' - ' + this.compTile + ' - ' + this.projTile + ' - ' + this.buildingTile;
          this.title = this.compTitle + ' - ' + this.LinkName;
          this.titleService.setTitle(this.title);
        }
      // }
    // }
  }
  
  changeTypeGallery(event) {
    this.galleryType = event.value;
  }

  listClick(event, newValue) {
    // this.showPage = newValue;
    if (this.itemContent != undefined && this.items != undefined) {
      this.itemContent = !this.itemContent;
      this.activeMobileMenu = false;
      this.selectedItem = newValue;  // don't forget to update the model here
      this.closeSubMenu.emit(false);
      if (this.selectedItem) {
        this.showCloser.emit(true);
      }
      // ... do other stuff here ...
    }
  }
  changeAutoPlay(item) {
    this.autoPlay = !this.autoPlay
  }

  changeShowThumbs(item) {
    this.showThumbs = !this.showThumbs
  }
  closeEdit() {
    this.selectedItem = {};
    this.closeSubMenu.emit(false);
    this.showCloser.emit(false);
  }
}
